<template>
  <error-page :status="$route.params.type"></error-page>
</template>

<script>
import errorPage from '../../components/error-page/error-page'
export default {
  name: 'error',
  components: { errorPage }
}
</script>

<style lang="less" scoped>
</style>
